import { FormattedMessage, useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";

import { formatRegisteredSymbol } from "./utils";

const EnterpriseStrategyAndPlanning = () => {
    const intl = useIntl();
    return (
        <TabsContent
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible",
                        defaultMessage: "Make all work visible in real-time"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible.bodytext",
                        defaultMessage:
                            "Spot and solve blockers faster with visibility into all work from teams across your enterprise."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam",
                        defaultMessage: "Align every team to strategy"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam.bodyText",
                        defaultMessage:
                            "Get everyone on the same page so you can solve for dependencies, scope, and roadmaps across teams and portfolios."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue",
                        defaultMessage: "Stay focused on customer value"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue.bodyText",
                        defaultMessage:
                            "Map investments to customer value creation so you can make confident decisions at make-or-break moments."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.learnMore",
                    defaultMessage: "Learn about enterprise strategy & planning"
                }),
                link: useLocalizedHref("/software/jira/align"),
                linkLabel: "Learn about enterprise strategy & planning",
                productKey: "enterprise"
            }}
            pictureProps={{
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1tu5g7e71x67ptt70udllxtw5705vl17.webp",
                    alt: "",
                    width: 1544,
                    height: 1092
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "EnterpriseLandingPage.tab.StrategyAndPlanning.resources",
                defaultMessage: "Enterprise strategy & planning resources"
            })}
            cardsContent={[
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport",
                        defaultMessage: "Report"
                    }),
                    headerText: (
                        <FormattedMessage
                            id="EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.headerText"
                            defaultMessage='Gartner<sup>®</sup> Predicts 2024: Strategic Portfolio Leaders Must Plan for the "Never Normal"'
                            values={formatRegisteredSymbol}
                        />
                    ),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.linkText",
                            defaultMessage: "Read report"
                        }),
                        href: useLocalizedHref(
                            "software/jira/align/resources/gartner-strategic-portfolio-management"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Read report"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kx4vls2kbgf442m7wq2p88a182k0sy20.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar",
                        defaultMessage: "Demo center"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.headerText",
                        defaultMessage:
                            "Learn how to boost Enterprise Strategy & Planning with Jira Align"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.linkText",
                            defaultMessage: "Explore demos"
                        }),
                        href: useLocalizedHref("/software/jira/align/demo"),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Explore demos"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-02-demo@2x-3880751788.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide",
                        defaultMessage: "Webinar"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.headerText",
                        defaultMessage:
                            "Transformations Across Hybrid Environments"
                    }),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.linkText",
                            defaultMessage: "Watch webinar"
                        }),
                        href: useLocalizedHref(
                            "/webinars/agile-at-scale/transformations-across-hybrid-environments"
                        ),
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Watch webinar"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kv2eo50o020nn5amk6ahukj52h35405s.webp",
                            alt: ""
                        }
                    }
                }
            ]}
        />
    );
};

export { EnterpriseStrategyAndPlanning };
